module.exports = __webpack_public_path__ + "media/images/article/2022_04_a-bbcd72168de02f3d9d835e36e00adcb3.png";